import Cookies from 'js-cookie';

(function ($, window) {
  $.fn.TimedPopup = function (options) {

    const defaults = {
      cookieValue: 'sent-away',
      permanentCookieValue: 'permanent',
      permanentCookieValueSelector: 'data-timed-popup-cookie-permanent-value',
      cookieNameAttr: 'data-timed-popup',
      autoOpen: true,
      autoOpenSelector: 'data-timed-popup-auto-open',
      delay: 0,
      delaySelector: 'data-timed-popup-delay',
      expiresMode: 'day',
      expiresModeSelector: 'data-timed-popup-mode',
      expires: 7,
      expiresSelector: 'data-timed-popup-expires',
      closeSelector: '[data-timed-popup-close]',
      queryParamSelector: 'data-timed-popup-query-param',
    };

    return this.each(function () {
      const $popup = $(this);
      const settings = $.extend({}, defaults, options);

      const cookieName = $popup.attr(settings.cookieNameAttr);
      if (!cookieName) {
        console.warn('TimedPopup: missing cookie name');
        return;
      }

      const cookieVal = Cookies.get(cookieName);

      // Helper function: read attribute with fallback
      const getPopupAttr = (name, fallback) => {
        const val = $popup.attr(name);
        return val !== undefined ? val : fallback;
      };

      // Permanent cookie value
      settings.permanentCookieValue = getPopupAttr(
        settings.permanentCookieValueSelector,
        settings.permanentCookieValue,
      );

      // Auto open
      const autoOpenAttr = getPopupAttr(settings.autoOpenSelector, null);
      settings.autoOpen =
        autoOpenAttr === null ? settings.autoOpen : autoOpenAttr !== 'false';

      // Delay
      const delayAttr = Number(
        getPopupAttr(settings.delaySelector, settings.delay),
      );
      settings.delay = isNaN(delayAttr) ? settings.delay : delayAttr;

      // Expires mode
      settings.expiresMode = getPopupAttr(
        settings.expiresModeSelector,
        settings.expiresMode,
      );

      // Expires
      const expiresAttr = parseInt(
        getPopupAttr(settings.expiresSelector, settings.expires),
        10,
      );
      settings.expires = isNaN(expiresAttr) ? settings.expires : expiresAttr;

      // Query param
      const queryParamName = getPopupAttr(settings.queryParamSelector, null);
      const [expectedQueryParamKey, ...expectedQueryParamValueParts] =
        queryParamName ? queryParamName.split('=') : [];

      const expectedQueryParamValue = expectedQueryParamValueParts.join('=');

      const searchParams = new URLSearchParams(window.location.search);
      const hasQueryParam = !queryParamName
        ? true
        : !!expectedQueryParamKey &&
          searchParams.has(expectedQueryParamKey) &&
          searchParams.get(expectedQueryParamKey) === expectedQueryParamValue;

      $popup.addClass('timed-popup__ready');

      const expiresValue = (() => {
        switch (settings.expiresMode) {
          case 'minute':
            return settings.expires / (24 * 60);
          case 'hour':
            return settings.expires / 24;
          default:
            return settings.expires;
        }
      })();

      // Helper function: set cookie
      const setCookie = (permanent = false) => {
        const current = Cookies.get(cookieName);
        if (current !== 'submitted') {
          Cookies.set(cookieName, settings.cookieValue, {
            expires: expiresValue,
          });
        }
      };

      // Show popup
      if (
        settings.autoOpen &&
        hasQueryParam &&
        cookieVal !== settings.cookieValue &&
        cookieVal !== settings.permanentCookieValue
      ) {
        window.setTimeout(function () {
          $popup.addClass('timed-popup__visible');
          $('body').addClass('open-newsletter-popup');
        }, settings.delay);
      }

      // Close selector click -> set cookie and close popup
      $popup.find(settings.closeSelector).on('click', function () {
        setCookie(false);
        $popup.removeClass('timed-popup__visible');
      });
    });
  }
})(jQuery, window);
